import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from './auth.service';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAdmin() && !auth.isAccessTokenExpired()) return true;
  if (!auth.refreshToken()) return router.createUrlTree(['/login']);
  return auth.refreshSession().pipe(
    map(() => auth.isAdmin() ? true : loginTree(router)),
    catchError(() => of(loginTree(router)))
  );
};

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.token() && !auth.refreshToken()) return true;
  if (auth.isAdmin() && !auth.isAccessTokenExpired()) return router.createUrlTree(['/notifications']);
  if (!auth.refreshToken()) return true;
  return auth.refreshSession().pipe(
    map(() => auth.isAdmin() ? router.createUrlTree(['/notifications']) : true),
    catchError(() => of(true))
  );
};

function loginTree(router: Router): UrlTree {
  return router.createUrlTree(['/login']);
}
